import { Link, useLocation } from "react-router-dom";
import { scrollToFocuse } from "../../../Layout/Common/common";
import { sameLayerState } from "../productPageOverlay/productPageOverlayContext";
import { isPlainLeftClick, useProductOverlay } from "../productOverlay/productOverlayContext";

export const SeeAllProductButton = () => {
  const location = useLocation();
  const productOverlay = useProductOverlay();
  const handleClick = (event) => {
    if (!productOverlay?.isOverlay || !isPlainLeftClick(event)) return;
    event.preventDefault();
    productOverlay.closeProduct();
  };
  return (
    <div className="create-favList my-3">
      <Link to={location.pathname} state={sameLayerState(location)} onClick={handleClick} data-overlay-skip="">
        See all product options
      </Link>
    </div>
  );
};

export const ViewAllProductButton = () => {
  const handleClick = () => {
    const id = document.getElementById("section-ProductsList");
    scrollToFocuse(id);
  };
  return (
    <div className="product-button button-effect productFamily-btn mt-3">
      <a role="button" onClick={handleClick} className="btn-products btn-addcart addToCart">
        View Products
      </a>
    </div>
  );
};
